import withSuspense from "../../../../hocs/withSuspense";
import { ContactInfoSkeleton, SettingsError } from "../../components";
import {
  EditPhoneNumberPage,
  EditPhoneNumberPageProps,
} from "./EditPhoneNumberPage";

export const EditPhoneNumberPageWithSuspense =
  withSuspense<EditPhoneNumberPageProps>(EditPhoneNumberPage, {
    FallbackComponent: SettingsError,
    loading: <ContactInfoSkeleton rows={1} testId="edit-phone" />,
  });
